export const iconFontAwesomeWritingThumbtack = (
	<i className="fa-solid fa-thumbtack"></i>
);
